import { memo, ReactElement } from 'react';
import { PracticeDetailVM } from 'practice/view-models/practice-detail';
import AccordionContacts from './accordion-contacts';
import AccordionCancellationPractice from './cancellation-practice';
import AccordionEndPractice from './end-cancellation-practice';
import AccordionReturnComunication from './return-comunication';
import AccordionPrintComunication from './print-comunication';
import AccordionPrintComunicazioneControInteressato from './print-comunicazione-contro-interessato';
import AccordionAttachments from './accordion-attachments';
import AccordionPositiveClosure from './positive-closure-practice';
import AccordionNegativeClosure from './negative-closure-practice';
import AccordionRequestAssessment from './accept-messi';
import AccordionIssuedAssessment from './accordion-issued-assessment';
import AccordionErrorClosurePractice from './practice-close-error';
import VerificationMessi from './verification-messi';
import AccordionRequestMessiVerification from './accordion-request-messi-verification';
import { PracticeData } from 'shell/models/practice';
import { PracticeManagementStep } from 'practice/constants/practice-management-step';
import VoidVerificationMessi from './void-verification-messi';
import AccordionRequestVerification from './accordion-request-verification';

interface ActiveStepProps {
  step?: number;
  disabled?: boolean;
  loadViewMessi: () => Promise<void>;
  loadUpdateDate: () => Promise<PracticeDetailVM> | void;
  isUnavailability?: boolean;
  tipoIniziativa?: string;
  noteMesso?: string;
  practiceData?: PracticeDetailVM;
  datiMesso?: PracticeData;
}

const ActiveStepComponent = ({
  step,
  disabled,
  loadViewMessi,
  loadUpdateDate,
  isUnavailability,
  tipoIniziativa,
  noteMesso,
  datiMesso,
  practiceData,
}: ActiveStepProps): ReactElement => {
  switch (step as PracticeManagementStep) {
    case PracticeManagementStep.RegistraRitornoAccertamentoMessi:
      return (
        <AccordionIssuedAssessment
          loadUpdateDate={loadUpdateDate}
          isUnavailability={isUnavailability}
          noteMesso={noteMesso}
        />
      );
    case PracticeManagementStep.RitornoAccertamentoMessi:
      return (
        <VerificationMessi
          loadUpdateDate={loadUpdateDate}
          isUnavailability={isUnavailability}
          noteMesso={noteMesso}
          loadViewMessi={loadViewMessi}
          datiMesso={datiMesso}
        />
      );
    case PracticeManagementStep.AnnulloAccertamento:
      return (
        <VoidVerificationMessi
          loadUpdateDate={loadUpdateDate}
          isUnavailability={isUnavailability}
          noteMesso={noteMesso}
          loadViewMessi={loadViewMessi}
          datiMesso={datiMesso}
        />
      );
    case PracticeManagementStep.RichiestaAccertamento:
      return (
        <AccordionRequestVerification
          loadViewMessi={loadViewMessi}
          loadUpdateDate={loadUpdateDate}
        />
      );
    case PracticeManagementStep.RichiestaUlterioriAccertamenti:
      return (
        <AccordionRequestAssessment loadViewMessi={loadViewMessi} loadUpdateDate={loadUpdateDate} />
      );
    case PracticeManagementStep.RichiestaUlterioreAccertamentoMessi:
      return (
        <AccordionRequestMessiVerification
          loadViewMessi={loadViewMessi}
          loadUpdateDate={loadUpdateDate}
        />
      );
    case PracticeManagementStep.RegistraSospensionePratica:
      return <AccordionCancellationPractice loadUpdateDate={loadUpdateDate} />;
    case PracticeManagementStep.RegistraFineSospensionePratica:
      return <AccordionEndPractice loadUpdateDate={loadUpdateDate} />;
    case PracticeManagementStep.StampaComunicazioneOstativa:
      return (
        <AccordionPrintComunication
          loadUpdateDate={loadUpdateDate}
          tipoIniziativa={tipoIniziativa}
        />
      );
    case PracticeManagementStep.RitornoComunicazioneOstativa:
      return <AccordionReturnComunication loadUpdateDate={loadUpdateDate} />;
    case PracticeManagementStep.StampaComunicazioneControInteressato:
      return <AccordionPrintComunicazioneControInteressato loadUpdateDate={loadUpdateDate} />;
    case PracticeManagementStep.Contatti:
      return <AccordionContacts disabled={disabled} />;
    case PracticeManagementStep.Allegati:
      return <AccordionAttachments disabled={disabled} />;
    case PracticeManagementStep.ChiusuraPositiva:
      return <AccordionPositiveClosure loadUpdateDate={loadUpdateDate} />;
    case PracticeManagementStep.ChiusuraNegativa:
      return (
        <AccordionNegativeClosure loadUpdateDate={loadUpdateDate} practiceData={practiceData} />
      );
    case PracticeManagementStep.ChiusuraPraticaErrore:
      return <AccordionErrorClosurePractice loadUpdateDate={loadUpdateDate} />;
    default:
      return <></>;
  }
};

ActiveStepComponent.displayName = 'Active step component';

const ActiveStep = memo(ActiveStepComponent) as typeof ActiveStepComponent;

export default ActiveStep;
